import type {Json} from '../Json';
import {
  type JsonAtomicStorage,
  KeyValueJsonAtomicStorageImpl,
} from '../JsonAtomicStorage';
import type {JsonKeyValueStorage} from '../JsonKeyValueStorage';
import type {OptionalGetter} from '../mobx-toolbox';
import {
  JsonCachedObservableAtomicValueImpl,
  type ObservableAtomicValue,
} from '../ObservableAtomicValue';

export default class SingleValueStorageImpl<T extends Json>
  extends JsonCachedObservableAtomicValueImpl<T>
  implements ObservableAtomicValue<T | undefined>, Disposable
{
  private constructor(
    root: {
      readonly jsonKeyValueStorage: JsonKeyValueStorage;
    },
    key: string,
    defaultValue: OptionalGetter<T | undefined> = undefined,
  ) {
    const jsonAtomicStorage = new KeyValueJsonAtomicStorageImpl(root, key);
    super(jsonAtomicStorage as JsonAtomicStorage<T>, defaultValue);
  }

  static create<K extends string, T extends Json>(
    root: {
      readonly jsonKeyValueStorage: JsonKeyValueStorage<{
        [P in K]: T;
      }>;
    },
    key: K,
    defaultValue: OptionalGetter<T | undefined> = undefined,
  ) {
    return new SingleValueStorageImpl(root, key, defaultValue);
  }
}
